export type RechargeItem = {
  total: string;
  price: string;
  add: string;
  id: string;
};

const defaultRechargeConfig: RechargeItem[] = [
  { total: '97500', price: '5.00', add: '7500', id: 'P30001001' },
  { total: '195000', price: '10.00', add: '15000', id: 'P30001002' },
  { total: '585000', price: '30.00', add: '45000', id: 'P30001003' },
  { total: '975000', price: '50.00', add: '75000', id: 'P30001004' },
  { total: '1950000', price: '100.00', add: '150000', id: 'P30001005' },
  { total: '5850000', price: '300.00', add: '450000', id: 'P30001006' },
  { total: '9750000', price: '500.00', add: '750000', id: 'P30001007' },
  { total: '15600000', price: '800.00', add: '1200000', id: 'P30001008' },
];

const agentRechargeConfig: RechargeItem[] = [
  // { total: '5850000', price: '300.00', add: '750000', id: 'P40001001' },
  { total: '9750000', price: '500.00', add: '1800000', id: 'P40001002' },
  { total: '19500000', price: '1000.00', add: '4000000', id: 'P40001003' },
  { total: '39000000', price: '2000.00', add: '4500000', id: 'P40001004' },
];

export function resolveRechargeConfig(rechargeAgent: string | null): RechargeItem[] {
  return rechargeAgent === '1' ? agentRechargeConfig : defaultRechargeConfig;
}

